import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { NotFoundPage } from '@/features/errors/NotFoundPage';
import { tokenStore } from '@/auth/token';
import { authKeys } from '@/queries/auth.queries';
import { authApi } from '@/api/auth.api';
import { useAuthStore } from '@/auth/useAuthStore';
import { APP_ROUTES } from '@/const/routes';

export const Route = createFileRoute('/app')({
  beforeLoad: async ({ context }) => {
    if (!tokenStore.get()) {
      throw redirect({ to: APP_ROUTES.login });
    }
    // Ensure meInfo is loaded before rendering any /app route
    const data = await context.queryClient.ensureQueryData({
      queryKey: authKeys.me(),
      queryFn: authApi.getMe,
      staleTime: 5 * 60 * 1000,
    });
    useAuthStore.getState().setMeInfo(data);
  },
  component: () => <Outlet />,
  notFoundComponent: NotFoundPage,
});
